import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";

export const usePublicationNetworksFeedStore = defineSmartFeedPiniaStore(
  "publication-networks-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          key: "publication_id",
          payload: useCreatorPublicationStore().publication.publication_id,
        },
      },
      tableFields: [
        { key: "name", label: "Name" },
        { key: "status", label: "Status" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/network/publication/${useCreatorPublicationStore().publication.publication_id}/networks`;
      },
    },
  },
);
